import { headerType } from '../../igao/utils'

import DynamicItem from './items/dynamic-Item'
import OtherItem from './items/other-item'
import StaticItem from './items/static-item'

const RenderItem = ({
  question,
  provided,
  items,
  applyChanges,
  icon,
  setModal,
  setEditable,
  editableQuestion,
  lists,
  page,
  setEditableQuestion,
  handleOnKeyDown,
  grid
}) => {
  const getItemStyle = draggableStyle => ({
    userSelect: 'none',
    margin: `0 0 ${grid}px 0`,
    color: '#9a9797',
    background: 'white',
    position: 'relative',
    alignItems: 'center',
    cursor: 'pointer',
    width: '100%',

    ...draggableStyle
  })

  if (headerType.includes(question.type)) {
    return (
      <StaticItem
        key={question.id}
        items={items}
        itemStyles={getItemStyle(provided.draggableProps.style)}
        applyChanges={applyChanges}
        actionIcon={icon}
        setEditable={setEditable}
        provided={provided}
        editableQuestion={editableQuestion}
        setEditableQuestion={setEditableQuestion}
        question={question}
        setModal={setModal}
      />
    )
  }
  if (question.type === 'other') {
    return (
      <OtherItem
        items={items}
        itemStyles={getItemStyle(provided.draggableProps.style)}
        provided={provided}
        setEditable={setEditable}
        question={question}
        setEditableQuestion={setEditableQuestion}
        editableQuestion={editableQuestion}
        applyChanges={applyChanges}
        setModal={setModal}
        actionIcon={icon}
      />
    )
  }
  return (
    <DynamicItem
      page={page}
      lists={lists}
      setModal={setModal}
      question={question}
      setEditableQuestion={setEditableQuestion}
      editableQuestion={editableQuestion}
      applyChanges={applyChanges}
      handleOnKeyDown={handleOnKeyDown}
      actionIcon={icon}
      provided={provided}
      setEditable={setEditable}
      itemStyles={getItemStyle(provided.draggableProps.style)}
    />
  )
}

export default RenderItem
